import { defineMessages, useIntl } from 'react-intl-next';

import { fg } from '@confluence/feature-gating';

const i18n = defineMessages({
	owner: {
		id: 'content-ownership.content-owner-item.owner',
		defaultMessage: 'Owner',
		description: 'A label distinguishing the user as the owner of a page',
	},
	creator: {
		id: 'content-ownership.content-owner-item.creator',
		defaultMessage: 'Creator',
		description: 'A label distinguishing the user as the person who created the blogpost',
	},
	ownerOrCreatorWithContributors: {
		id: 'content-ownership.content-owner-item.owner-or-creator-with-contributors',
		defaultMessage:
			'{isBlogpost, select, true {Creator} other {Owner}}{noOtherContributors, select, true {, no contributors} other {}}',
		description:
			'A label showing whether the user is an owner or creator, and if there are other contributors',
	},
});

type useUserTitleParams = {
	contentType?: string | null;
	noOtherContributors?: boolean;
};

export const useUserTitle = ({ contentType, noOtherContributors }: useUserTitleParams): string => {
	const { formatMessage } = useIntl();

	const isBlogpost = contentType === 'blogpost';
	if (fg('page_byline_owner_and_contributors_dropdown')) {
		return formatMessage(i18n.ownerOrCreatorWithContributors, {
			isBlogpost,
			noOtherContributors,
		});
	}
	// blogposts dont have the "owner" concept because they arent meant to be living objects live pages are. so we just refer to the creator.
	return isBlogpost ? formatMessage(i18n.creator) : formatMessage(i18n.owner);
};
